import { Component, OnInit } from '@angular/core'

import { LOCAL_STORAG_KEYS } from '@@constants/local-storage-keys'
import cryptoDecryptData from '@@utils/cryptoDecryptData'
import { AuthService } from '@@services/auth.service'

import { environment } from 'src/environments/environment'

@Component({
    standalone: false,
    selector: 'app-zoho-sync',
    templateUrl: './zoho-sync.component.html',
    styleUrls: ['./zoho-sync.component.css']
})
export class ZohoSyncComponent implements OnInit {
    url = 'https://accounts.zoho.com/oauth/v2/auth'
    scope = 'ZohoBooks.fullaccess.all'

    response_type = 'code'
    redirect_uri = environment.apiUrl + 'html/zoho'
    client_id?: any
    state = localStorage.getItem(LOCAL_STORAG_KEYS.TENANT_ID)

    constructor(private authService: AuthService) {}

    ngOnInit() {
        let encrypted = localStorage.getItem(LOCAL_STORAG_KEYS.ZOHO_CLIENT_ID)
        if (encrypted) {
            this.client_id = cryptoDecryptData(encrypted)
        }
    }

    syncZohoData() {
        if (this.client_id && this.authService.userIsOwner()) {
            ;(
                document.forms.namedItem('zoho-sync-form') as HTMLFormElement
            ).submit()
        }
    }
}
